export enum CategoriaContaPagarEnum {
    Aluguel = 1,
    Luz = 2,
    Internet = 3,
    Agua = 4,
    Combustivel = 5,
    Imposto = 6,
    Marketing = 7,
    Sistemas = 8,
    Telefone = 9
}

export const CategoriaContaPagarLabel = new Map<number, string>([
    [CategoriaContaPagarEnum.Aluguel, 'Aluguel'],
    [CategoriaContaPagarEnum.Luz, 'Luz'],
    [CategoriaContaPagarEnum.Internet, 'Internet'],
    [CategoriaContaPagarEnum.Agua, 'Agua'],
    [CategoriaContaPagarEnum.Combustivel, 'Combustivel'],
    [CategoriaContaPagarEnum.Imposto, 'Imposto'],
    [CategoriaContaPagarEnum.Marketing, 'Marketing'],
    [CategoriaContaPagarEnum.Sistemas, 'Sistemas'],
    [CategoriaContaPagarEnum.Telefone, 'Telefone'],
]);
